<template>
	<div class="personHome">
		<div class="topTitle bd10 p3">
			<div class="sTitle d-flex a-center j-sb">
				 <h3 class="font20">{{content.activity.title}}</h3>
				 <a class="link font-light cor999" @click="$router.go(-1);" href="javascript:;">{{$t('admin.back')}} &gt;</a>
			</div>
		</div>
		
		<div class="psLeftContent d-flex">
			<!-- 活动信息 -->
			<div class="state p3 bd10 pr">
				<div :class="['icon d-flex a-center', {active: content.activity.applyType == 1 || content.activity.applyType == 2}]">
					<span v-if="content.activity.applyType == 1">{{$t('show.noStart')}}</span>
					<span v-if="content.activity.applyType == 2">{{$t('show.entrying')}}</span>
					<span v-if="content.activity.applyType == 3">{{$t('show.end')}}</span>
				</div>
				<div class="sTitle d-flex a-center j-sb">
					 <h3 class="font20">{{$t('admin.activityInfo')}}</h3>
				</div>
				<dl class="line-sm">
					<dd class="d-flex j-sb"><i class="font-light">{{$t('admin.stateDate')}}</i><span>{{content.activity.beginDate}}</span></dd>
					<dd class="d-flex j-sb"><i class="font-light">{{$t('admin.endDate')}}</i><span>{{content.activity.endDate}}</span></dd>
					<dd class="d-flex j-sb"><i class="font-light">{{$t('admin.address')}}</i><span>{{content.activity.address}}</span></dd>
				</dl>
			</div>
			<!-- 我的产品 -->
			<div class="item">
				<div class="text bd10 p3">
					<div class="sTitle d-flex a-center j-sb">
						 <h3 class="font20">{{$t('admin.emtryInfo')}}</h3>
					</div>
					<div class="enterInfo">
						<dl class="d-flex f-wrap">
							<dd>
								<div class="label font-light">{{$t('admin.username')}}</div>
								<div class="value">{{content.realName}}</div>
							</dd>
							<dd>
								<div class="label font-light">{{$t('admin.phone')}}</div>
								<div class="value">{{content.mobile}}</div>
							</dd>
							<dd>
								<div class="label font-light">{{$t('admin.companyEmail')}}</div>
								<div class="value">{{content.email}}</div>
							</dd>
							<dd>
								<div class="label font-light">{{$t('admin.company')}}</div>
								<div class="value">{{content.company}}</div>
							</dd>
							<dd>
								<div class="label font-light">{{$t('admin.job')}}</div>
								<div class="value">{{content.job}}</div>
							</dd>
							<dd>
								<div class="label font-light">{{$t('admin.industry')}}</div>
								<div class="value">{{content.industry}}</div>
							</dd>
						</dl>
					</div>
				</div>
			</div>
			
		</div>
		
	</div>
</template>

<script>
export default {
  name: 'EnterDetail',
  components: {
    
  },
  data() {
    return {
		// 详细信息
		content: {
			activity: {
				title: ''
			}
		},
	}
  },
  
  created() {
  	  // 获取详细信息
  	  this.getContentInfo(this.$route.query.id);
  	 
  },
  
  methods: {
  	 // 获取详细信息
  	 getContentInfo(id) {
		  this.$axios.get(`member/applyDetails?id=${id}`)
		  .then(res => {
			 this.content = res.data;
		  })
		  .catch(err=>{})
  	 },
  }
}
</script>

<style lang="less" scoped>
	.personHome{
		.topTitle{
			margin-bottom: 0.1rem;
			.sTitle{
				margin-bottom: 0;
				h3{
					width: 80%;
				}
			}
		}
		.psLeftContent{
			flex-direction: row-reverse;
			.item{
				width: 70%;
				.text{
					border-top-right-radius: 0;
					border-bottom-right-radius: 0;
					padding-bottom: .8rem;
				}
				.enterInfo{
					max-width: 8rem;
					dl {
						margin-top: -.5rem;
						dd{
							width: 48%;
							margin-top: .5rem;
							.label{
								padding-bottom: 0.1rem;
								border-bottom: solid 1px #eee;
								margin-bottom: 0.2rem;
							}
						}
						
					}
				}
			}
			.state{
				width: 30%;
				background-image: linear-gradient(#f2f5fa, #fff);
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
				.icon{
					position: absolute;
					right: 0;
					top: 0;
					width: .9rem;
					height: .3rem;
					line-height: .3rem;
					color: #fff;
					text-indent: .3rem;
					background: url(@/assets/Icons/enterBgGray.png) no-repeat center/100% 100%;
					&.active{
						background-image: url(@/assets/Icons/enterBgBlue.png);
					}
				}
				dl{
					dd{
						padding-left: .3rem;
						position: relative;
						padding-bottom: .3rem;
						margin-bottom: .1rem;
						&:after{
							content: "";
							position: absolute;
							left: 0;
							top: .08rem;
							width: .08rem;
							height: .08rem;
							border-radius: 50%;
							background: #2657db;
						}
						&:before{
							content: "";
							position: absolute;
							left: .04rem;
							top: .24rem;
							width: 1px;
							height: calc(100% - .18rem);
							border-radius: 50%;
							background: #ced9f7;
						}
						&:last-child{
							margin-bottom: 0;
							padding-bottom: 0;
						}
						&:last-child:before{
							display: none;
						}
					}
				}
			}
		}
		@media (max-width: 640px) {
			padding: .2rem;
			.topTitle{
				position: relative;
				padding-top: 0.5rem;
				.sTitle {
					a{
						position: absolute;
						right: 0.1rem;
						top: 0.1rem;
					}
					h3{
						width: 100%;
					}
				}
			}
			.psLeftContent{
				display: block;
				.state,.item{
					width: 100%;
				}
				.state{
					margin-bottom: .1rem;
				}
				.item{
					.enterInfo{
						dl{
							dd{
								width: 100%;
							}
							
						}
					}
				}
				
			}
		}
	}
</style>
